export default "__VITE_ASSET__BhH4PTyr__"